export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.lenis) window.lenis.scrollTo(el, { offset: -80, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};
